const About = () => {
    return (
        <div>
            Minim laboris esse et mollit aute tempor mollit laborum id. Consequat commodo est ut et laboris. Exercitation incididunt reprehenderit voluptate magna elit amet ea esse nulla cillum dolore. Proident sit deserunt fugiat est.
        </div>
    )
}

export default About
